
import { InjectionToken } from '@angular/core';
import { Gigya, OnGigyaServiceReady } from '../models/gigya';

export type DefineFn = ((name, dependencies, factory) => void) & {
  amd: any
};

export type Global = Window & Partial<{
  QSI?: any;
  require: any;
  define: DefineFn;
  gigya: Gigya;
  onGigyaServiceReady: OnGigyaServiceReady;
  isHMR: boolean;
  isNgServer: boolean;
  encodeURIComponent(uriComponent: string | number | boolean | null | undefined | object): string;
}>;

const global: Global = window;

export const GLOBAL = new InjectionToken<Global>('global', {
  providedIn: 'any',
  factory: /* istanbul ignore next */ () => global
});
